/* Новые компоненты */
import SkInput from '@/components/ui/SkInput/SkInput.vue'
//import SkNumberInput from '@/components/ui/SkInput/SkNumberInput.vue'
//import SkTextarea from '@/components/ui/SkTextarea/SkTextarea.vue'
import SkSelect from '@/components/ui/SkSelect/SkSelect.vue'
//import SkRadioGroup from '@/components/ui/SkRadio/SkRadioGroup.vue'
//import SkRadio from '@/components/ui/SkRadio/SkRadio.vue'
import SkSwitch from '@/components/ui/SkSwitch/SkSwitch.vue'
import SkButton from '@/components/ui/Button/SkButton.vue'
//import SkSlider from '@/components/ui/SkSlider/SkSlider.vue'
//import SkDialog from '@/components/ui/SkDialog/SkDialog.vue'
import SkIcon from '@/components/ui/SkIcon/SkIcon.vue'
import SkifCheckboxNew from '@/components/ui/Checkbox/Checkbox.vue'
//import ExTableColumn from 'ex-table-column'

// функция для регистрации плагинов и глобальных компонентов
export function registerGlobalComponents(app) {
  // Компоненты
  // app.component('skifRadio', SkifRadio)
  // app.component('skifRadioOld', SkifRadioOld)
  // app.component('skifButton', SkifButton)
  // app.component('skifBadge', SkifBadge)
  app.component('SkifCheckbox', SkifCheckboxNew) // Обновленный компонент для Vue 3
  // app.component('skifCheckboxOld', SkifCheckboxOld)
  // app.component('skifFilter', SkifFilter)
  // app.component('skifSearch', SkifSearch)
  // app.component('skifInputNumber', SkifInputNumber)
  // app.component('skifSwitch', SkifSwitch)

  /* Новые компоненты */
  app.component('SkInput', SkInput)
  //app.component('SkNumberInput', SkNumberInput)
  app.component('SkSelect', SkSelect)
  //app.component('SkTextarea', SkTextarea)
  //app.component('SkRadioGroup', SkRadioGroup)
  //app.component('SkRadio', SkRadio)
  app.component('SkSwitch', SkSwitch)
  app.component('SkButton', SkButton)
  //app.component('SkSlider', SkSlider)
  //app.component('SkDialog', SkDialog)
  app.component('SkIcon', SkIcon)
}
